import React, { useEffect, useState } from "react";
import Button from "@components/buttons/Button/Button";
import { getRootDomain } from "@util/domain";
import {
    AnalyticsConsent,
    CONSENT_SETTINGS_EVENT,
    getAnalyticsConsent,
    initGA,
    needsAnalyticsConsent,
    setAnalyticsConsent,
    trackPageView,
} from "@util/ga";
import styles from "./ConsentBanner.module.css";

// Analytics consent bar for the International hub, matching the branded website.
// Shown until the visitor chooses, and again from the footer "Cookie Settings" link.
// Accept and Reject have equal weight.
const ConsentBanner: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!needsAnalyticsConsent()) return () => {};
        setVisible(getAnalyticsConsent() === null);
        const open = () => setVisible(true);
        window.addEventListener(CONSENT_SETTINGS_EVENT, open);
        return () => window.removeEventListener(CONSENT_SETTINGS_EVENT, open);
    }, []);

    const choose = (value: AnalyticsConsent) => {
        setAnalyticsConsent(value);
        setVisible(false);
        if (value === "granted") {
            initGA();
            trackPageView(window.location.pathname + window.location.search);
        }
    };

    if (!visible) return null;

    return (
        <div className={styles.banner} role="region" aria-labelledby="consent-banner-title">
            <p id="consent-banner-title" className={styles.title}>Cookies</p>
            <p className={styles.text}>
                We&apos;d like to use optional analytics cookies to see how this site is used and
                improve it. They are only set if you accept, and you can change your choice anytime
                from Cookie Settings in the footer.
                {" "}
                <a
                    href={`${getRootDomain()}/privacy-policy`}
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
            </p>
            <div className={styles.buttons}>
                <Button variant="primary" onClick={() => choose("denied")}>Reject</Button>
                <Button variant="primary" onClick={() => choose("granted")}>Accept</Button>
            </div>
        </div>
    );
};

export default ConsentBanner;
